import './categoryItem.scss';
export class CategoryItemController {
    static $inject = ['CurrentApplicationService', 'SegmentService'];
    constructor(CurrentApplicationService, SegmentService) {
        this.CurrentApplicationService = CurrentApplicationService;
        this.SegmentService = SegmentService;
        this.elementId = 'category';
    }
    async $onInit() {
        this.name = this.data.category;
        this.id = this.data.id;
    }
    $deleteModel(event) {
        event.stopPropagation();
        event.preventDefault();
        this.onDelete({ $item: this.data });
    }
    async createTrack() {
        try {
            const application = await this.CurrentApplicationService.fetchApplication();
            this.SegmentService.createBotTrack('helpdesk-custom-replies-category-opened', application);
        }
        catch (e) {
            console.error(e);
        }
    }
}
CategoryItemController.$inject = ['CurrentApplicationService', 'SegmentService'];
